import React from 'react';
import { useModal } from '../../../hooks/useModal';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../translations';

const SeasonBonusModal = React.forwardRef(function SeasonBonusModal(props, ref) {
  const { title, text, button } = props;
  const { closeModal, id } = useModal();
  const { t } = useTranslation();
  const handleClose = () => {
    closeModal(id);
  };

  return (
    <CustomModal>
      <div className={'season-bonus-modal'} ref={ref}>
        <p className={`season-bonus-modal__title`}>{safeHTML(t(title))}</p>
        <p className={`season-bonus-modal__text`}>{safeHTML(t(text))}</p>
        <CustomButton {...button} onClick={handleClose} />
      </div>
    </CustomModal>
  );
});
export default SeasonBonusModal;
SeasonBonusModal.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.object.isRequired,
  closeCallback: PropTypes.func,
};
